import { render, staticRenderFns } from "./JobworkDeliveryView.vue?vue&type=template&id=65471267&scoped=true"
import script from "./JobworkDeliveryView.vue?vue&type=script&lang=js"
export * from "./JobworkDeliveryView.vue?vue&type=script&lang=js"
import style0 from "./JobworkDeliveryView.vue?vue&type=style&index=0&id=65471267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65471267",
  null
  
)

export default component.exports